export default "__VITE_ASSET__YGi43DMY__"